###
Gridspy Calendar code

Based on code from https://github.com/jjperezaguinaga/Knockout-Calendar

Copyright (c) 2012 Gridspy Ltd
All Rights Reserved
###

class Week
  constructor: (Days)->
    @days   = ko.observable(Days);

class Day 
  constructor: (@delta, parent, index, row)->
    @day  = ko.computed => 
      new Date(parent.first_day()).add(@delta).days()
      
    @index  = ko.observable(index)
    @row  = ko.observable(row)
  
    # TO STRING
    @day_number = ko.computed => @day().toString('d')
    @day_name   = ko.computed => @day().toString('ddd')
    @month_year  = ko.computed => @day().toString('MMM yyyy')
    @month_name  = ko.computed => @day().toString('MMM').toLowerCase()
  
    @select_day = =>
      console?.log "Set day", @day()
      gs.bindings.set_day @day()
    
    @day_url = ko.computed
      deferEvaluation: true
      read: => 
        gs.bindings.url_for  
          date:@day()

class CalendarViewModel
  constructor: (@context) ->
    @selected_day = ko.computed
      read: => @context.end()
      write: (newVal) =>
        @context.end newVal
        @context.recalculate_times()
    
    @first_day = ko.observable new Date(@selected_day()).set(day:1).monday().add(-2).weeks()
    
    @weeks    = ko.observable []
    @weeks_name = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  
    @rows    = ko.observable(7);
    @cols    = ko.observable(7);
  
    #GENERATE WEEK DAYS (To be replace by $.getJSON('server/dates, function(){})'))
    @load_data()
    
  centre: ->
    if @weeks()[2].days()[0].day() < @selected_day() < @weeks()[@rows()-2].days()[0].day()
      return
      
    @first_day new Date(@selected_day()).clearTime().set(day:1).monday().add(-2).weeks()

  prev_week: () =>
    @selected_day @selected_day().add(-1).weeks()
    @centre()

  next_week: () =>
    @selected_day @selected_day().add(1).weeks()
    @centre()

  prev_month: () =>
    @selected_day @selected_day().add(-1).months()
    @centre()

  next_month: () =>
    @selected_day @selected_day().add(1).months()
    @centre()

  scroll_prev_week: () =>
    @first_day(@first_day().add(-1).weeks())
    
  scroll_next_week: () =>
    @first_day(@first_day().add(1).weeks())

  set_selected:(day_time) =>
    @selected_day day_time
    @centre() 

  load_data: () ->
    delta = 0
    #today = new Date(@first_day)
    for j in [0...@rows()]
      Days = [];
      for i in [0...@cols()]
        Days[i] = new Day(delta, @, i, j)
        delta += 1
      @weeks()[j] = new Week(Days)

    

if not window.gs?
  window.gs = {}
window.gs.CVM = CalendarViewModel


